import BBBBadge from "@/app/layouts/standard/footer/bbbBadge";
import GoogleReviewBadge from "@/app/layouts/standard/footer/googleReviewBadge";
import TrustPilotBadge from "@/app/layouts/standard/footer/trustPilotBadge";
import cn from "classnames";
import Image from "next/image";
import React from "react";
import styles from "./trustBadges.module.scss";

type Badge = {
  id: "google" | "trustpilot" | "bbb" | "hq";
  name: string;
  src?: string;
  Cmp?: React.ComponentType<any>;
  alt: string;
  href?: string;
  className?: string;
  props?: { theme: string; className: string };
};

const badges: Badge[] = [
  {
    id: "google",
    name: "Google Reviews",
    Cmp: GoogleReviewBadge,
    alt: "Google Reviews Badge",
    href: "https://www.google.com/storepages?q=net32.com&c=US&v=19&hl=en",
    className: `${styles.badgeGoogle} googlebadgestyles`,
  },
  {
    id: "trustpilot",
    name: "Trustpilot",
    Cmp: TrustPilotBadge,
    alt: "Trustpilot Badge",
    href: "https://www.trustpilot.com/review/net32.com?utm_medium=trustbox&utm_source=Mini",
    className: styles.badgeTrustpilot,
    props: { theme: "light", className: styles.trustpilotBadge },
  },
  {
    id: "bbb",
    name: "Better Business Bureau",
    Cmp: BBBBadge,
    alt: "Better Business Bureau Badge",
    href: "https://www.bbb.org/us/nc/cary/profile/dental-supplies/net32-inc-0593-90055367#bbbseal",
    className: styles.badgeBbb,
  },
  {
    id: "hq",
    name: "Headquartered in USA",
    src: "/next-public/badges/net32-headquartered.png",
    alt: "Headquartered Badge",
    className: styles.badgeHq,
  },
];

interface TrustBadgesProps {
  /** When true, the badge row spans the full page width instead of being capped at the header's 1440px width. */
  fullWidth?: boolean;
}

function TrustBadges({ fullWidth = false }: TrustBadgesProps) {
  return (
    <div className={cn(styles.trustBadges, { [styles.fullWidth]: fullWidth })}>
      {badges.map(({ Cmp, ...b }) => {
        const Img = b.src ? (
          <Image
            src={b.src}
            alt={b.alt}
            width={0}
            height={0}
            sizes="100vw"
            style={{ width: "100%", height: "auto" }}
            unoptimized
          />
        ) : null;

        return (
          <div key={b.id} className={cn(b.className)}>
            {b.href ? (
              <div aria-label={b.name}>
                {Img}
                {Cmp && <Cmp {...b.props} />}
              </div>
            ) : (
              <span aria-label={b.name}>{Img}</span>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default TrustBadges;
